export class MessageDialogModel {
  constructor(public title: string, public message: string) {
  }
}
  